/**
 * @export
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function initDetailLines(state, action) {
	const { lines, prefix } = action.payload;

	if (prefix === 'view') {
		return {
			...state,
			view: {
				...state.view,
				detail: {
					...state.view.detail,
					linesData: lines,
				},
			},
		};
	} else if (prefix.startsWith('popups/')) {
		const popupIndex = parseInt(prefix.split('/')[1], 10);

		if (!isNaN(popupIndex) && popupIndex >= 0 && popupIndex < state.popups.length) {
			const updatedPopups = [...state.popups];
			updatedPopups[popupIndex] = {
				...updatedPopups[popupIndex],
				detail: {
					...state.view.detail,
					linesData: lines,
				},
			};

			return {
				...state,
				popups: updatedPopups,
			};
		}
	}

	return state;
}
